(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sara-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var w = e.target.closest('.so-wl');
  if (!w) return;
  var on = w.getAttribute('aria-pressed') === 'true';
  w.setAttribute('aria-pressed', String(!on));
  w.innerHTML = on ? '&#9825;' : '&#9829;';
});
(function () {
  var els = document.querySelectorAll('.so-rv');
  if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('in'); }); return; }
  var io = new IntersectionObserver(function (en) {
    en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
  }, { threshold: 0.1 });
  els.forEach(function (el) { io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();
})();
